import { Box, Button, Stack, styled, Typography } from '@mui/material';
export const Container = styled(Stack)(() => ({
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    margin: '0 auto',
}));
export const ContentContainer = styled(Stack)(({ theme }) => ({
    margin: '0 auto',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(6),
    [theme.breakpoints.up('md')]: {
        justifyContent: 'center',
        maxWidth: '36rem',
        gap: theme.spacing(9),
    },
}));
export const LogoContainer = styled(Box)(({ theme }) => ({
    width: '100%',
    display: 'flex',
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
    justifyContent: 'center',
    alignItems: 'flex-end',
    [theme.breakpoints.up('md')]: {
        paddingTop: theme.spacing(9),
        paddingRight: theme.spacing(9),
        justifyContent: 'flex-end',
    },
}));
export const PromptImageContainer = styled(Stack)(({ theme }) => ({
    margin: '0 auto',
    maxWidth: '17rem',
    [theme.breakpoints.up('md')]: {
        maxWidth: '28rem',
    },
}));
export const Text = styled(Typography)(({ theme }) => ({
    textAlign: 'center',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
    fontSize: theme.spacing(3.5),
    lineHeight: theme.spacing(4.5),
    color: theme.palette.primary.main,
    fontVariant: 'body2',
    [theme.breakpoints.up('md')]: {
        fontSize: theme.spacing(5),
        lineHeight: theme.spacing(6.5),
        fontVariant: 'subtitle2',
    },
}));
export const UnpinnedContent = styled(Stack)(({ theme }) => ({
    padding: theme.spacing(0, 4),
    marginBottom: theme.spacing(20),
    gap: theme.spacing(4),
    width: '100%',
    overflow: 'auto',
    [theme.breakpoints.up('md')]: {
        gap: theme.spacing(6),
        flex: 1,
        marginBottom: 0,
        padding: 0,
    },
}));
export const PinnedContent = styled(Box)(({ theme }) => ({
    padding: theme.spacing(4),
    // only for mobile
    [theme.breakpoints.down('md')]: {
        position: 'fixed',
        bottom: 0,
        width: '100%',
        display: 'flex',
        gap: theme.spacing(3),
        maxHeight: theme.spacing(40),
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: `#FAF9F9`, // this colour is not available in design system
        boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.4)',
    },
}));
export const ContinueButton = styled(Button)(({ theme }) => ({
    width: theme.spacing(75),
    display: 'inline-flex',
    [theme.breakpoints.up('md')]: {
        display: 'none',
    },
}));
//# sourceMappingURL=data:application/json;base64,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